import { Task } from '@/types';
import { mockTasks } from '@/data/mockTasks';
import { mockInterventionTasks } from '@/data/mockInterventionTasks';
import { taskStorage } from '../services/taskStorage';

export const generateInterventionTasks = (studentId: string, interventionId: string): Task[] => {
  const allTasks = [...mockTasks, ...mockInterventionTasks];
  const numTasks = Math.floor(Math.random() * 7) + 4; // 4-10 tasks
  const now = new Date().toISOString();
  
  // Create a pool of tasks based on intervention needs
  const taskPool = allTasks
    .sort(() => Math.random() - 0.5) // Shuffle tasks
    .slice(0, numTasks)
    .map(task => {
      const newTask = {
        ...task,
        id: `${task.id}-${interventionId}-${studentId}`,
        interventionId,
        assignedTo: studentId,
        status: ['not_started', 'in_process', 'completed'][Math.floor(Math.random() * 3)] as Task['status'],
        dueDate: new Date(Date.now() + (Math.random() * 30 + 1) * 24 * 60 * 60 * 1000).toISOString(),
        createdAt: now,
        updatedAt: now,
        comments: [],
        reminders: [],
        attachments: []
      };

      // Save each task to storage
      const savedTask = taskStorage.saveTask(newTask);
      if (!savedTask) {
        console.error(`Failed to save task ${newTask.id}`);
        return null;
      }

      return savedTask;
    })
    .filter((task): task is Task => task !== null);

  return taskPool;
};